module.exports = __webpack_public_path__ + "img/section2.f6fd946a.png";